var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Service from '@ember/service';
import { getOwner } from '@ember/application';
import { action } from '@ember/object';
import { run } from '@ember/runloop';
import { keyDown, keyPress, keyUp } from 'ember-keyboard/listeners/key-events';
import { handleKeyEventWithPropagation } from 'ember-keyboard/utils/handle-key-event';
import { reverseCompareProp } from 'ember-keyboard/utils/sort';
let KeyboardService = (_class = class KeyboardService extends Service {
  get activeResponders() {
    let {
      registeredResponders
    } = this;
    return Array.from(registeredResponders).filter(r => r.keyboardActivated);
  }
  get sortedResponders() {
    return this.activeResponders.sort((a, b) => {
      return reverseCompareProp(a, b, 'keyboardPriority');
    });
  }
  get firstResponders() {
    return this.sortedResponders.filter(r => r.keyboardFirstResponder);
  }
  get normalResponders() {
    return this.sortedResponders.filter(r => !r.keyboardFirstResponder);
  }
  constructor(...args) {
    super(...args);
    _defineProperty(this, "registeredResponders", new Set());
    if (typeof FastBoot !== 'undefined') {
      return;
    }
    const config = getOwner(this).resolveRegistration('config:environment') || {};
    let emberKeyboardConfig = config.emberKeyboard || {};
    if (emberKeyboardConfig.disableOnInputFields) {
      this._disableOnInput = true;
    }
    this._listeners = emberKeyboardConfig.listeners || ['keyUp', 'keyDown', 'keyPress'];
    this._listeners = this._listeners.map(listener => listener.toLowerCase());
    this._listeners.forEach(type => {
      document.addEventListener(type, this._respond);
    });
  }
  willDestroy(...args) {
    super.willDestroy(...args);
    if (typeof FastBoot !== 'undefined') {
      return;
    }
    this._listeners.forEach(type => {
      document.removeEventListener(type, this._respond);
    });
  }
  _respond(event) {
    if (this._disableOnInput && event.target) {
      const tag = event.target.tagName;
      const isContentEditable = event.target.getAttribute && event.target.getAttribute('contenteditable') != null;
      if (isContentEditable || tag === 'TEXTAREA' || tag === 'INPUT') {
        return;
      }
    }
    run(() => {
      let {
        firstResponders,
        normalResponders
      } = this;
      handleKeyEventWithPropagation(event, {
        firstResponders,
        normalResponders
      });
    });
  }
  register(responder) {
    this.registeredResponders.add(responder);
  }
  unregister(responder) {
    this.registeredResponders.delete(responder);
  }
  keyDown(...args) {
    return keyDown(...args);
  }
  keyPress(...args) {
    return keyPress(...args);
  }
  keyUp(...args) {
    return keyUp(...args);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "_respond", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_respond"), _class.prototype)), _class);
export { KeyboardService as default };